module.exports = __webpack_public_path__ + "static/media/erp_dashboard.9aebc27a.jpg";